export enum MaintenanceType {
    global = 'global',
    sport = 'sport',
    live = 'live',
    casino = 'casino',
    casinoLive = 'casinolive',
    lotto = 'lotto',
    virtual = 'virtuals',
    sportResults = 'sport_results',
    liveResults = 'live_results',
    lottoResults = 'lotto_results',
    virtualShopResults = 'virtuals_shop_results',
    virtualOnlineResults = 'virtuals_online_results'
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/models/country/enums.ts